import { Link } from 'react-router-dom';
import { primaryNavLinks } from '@/config/navLinks';

const serviceFooterLinks: { label: string; to: string }[] = [
  { label: 'Kombi Tamiri', to: '/kombi-tamiri' },
  { label: 'Kombi Bakımı', to: '/kombi-bakimi' },
  { label: 'Kombi Montajı', to: '/kombi-montaji' },
  { label: 'Kombi Parça Değişimi', to: '/kombi-tamiri' },
  { label: 'Petek Temizliği', to: '/hizmetler' },
];

export default function Footer() {
  return (
    <footer className="bg-white">
      <div className="border-t border-[#dbeafe]">
        <div className="max-w-6xl mx-auto px-4 md:px-8 py-10 md:py-14">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-primary rounded-xl">
                <i className="ri-fire-fill text-white text-lg" />
              </div>
              <div className="leading-tight">
                <span className="block text-sm font-bold text-slate-900">Kombi Kurumsal Servis</span>
                <span className="block text-[11px] text-primary font-medium">Kombi Tamiri & Bakımı</span>
              </div>
            </div>
            <p className="text-sm text-slate-600 leading-relaxed mb-4">
              ECA, Demirdöküm, Airfel, Bosch, Vaillant ve tüm marka kombilere uzman tamiri, bakım ve montaj hizmeti sunuyoruz. Yerinde servis, orijinal parça ve garanti.
            </p>
            <a
              href="tel:05332836679"
              className="inline-flex items-center gap-2 text-sm font-bold text-slate-700 hover:text-primary transition-colors"
            >
              <i className="ri-phone-fill text-primary" />
              7/24 Çağrı: 0533 283 66 79
            </a>
          </div>

          {/* Nav */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-slate-400 mb-4">Hızlı Menü</h4>
            <ul className="flex flex-col gap-2.5">
              {primaryNavLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-slate-600 hover:text-primary transition-colors text-left block"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-slate-400 mb-4">Kombi Hizmetlerimiz</h4>
            <ul className="flex flex-col gap-2.5">
              {serviceFooterLinks.map((s) => (
                <li key={s.label}>
                  <Link
                    to={s.to}
                    className="text-sm text-slate-600 hover:text-primary transition-colors text-left block"
                  >
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          </div>

          <div className="border-t border-[#dbeafe] mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-slate-400 text-center sm:text-left">
              © {new Date().getFullYear()} Kombi Kurumsal Servis
            </p>
            <a
              href="tel:05332836679"
              className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white text-sm font-bold px-5 py-2.5 rounded-full transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-fill" />
              Hemen Ara
            </a>
          </div>
        </div>
      </div>

      <div className="bg-[#1a2332] py-2.5 md:py-3">
        <div className="max-w-6xl mx-auto px-4 md:px-8 flex justify-center">
          <a
            href="https://epiked.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex flex-wrap items-center justify-center gap-2 sm:gap-2.5 rounded-md outline-none transition-opacity hover:opacity-90 focus-visible:ring-2 focus-visible:ring-white/40 focus-visible:ring-offset-2 focus-visible:ring-offset-[#1a2332]"
          >
            <img
              src="/images/elogo.avif"
              alt="Epiked"
              className="h-5 sm:h-6 w-auto max-w-[112px] sm:max-w-[120px] object-contain shrink-0"
              loading="lazy"
              decoding="async"
            />
            <span className="text-[10px] sm:text-xs text-white font-medium tracking-tight text-center leading-snug">
              Profesyonel web sistemleri ile hazırlanmıştır.
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
}